// ProposalDetailPage.tsx
import React, { useCallback, useEffect, useState } from "react";
import { Grid, Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { proposalApi } from "../api/proposalApi";
import { ConvertProposalDetail, ProposalDetail } from "../model/proposalDetail.ui";
import { PATHS } from "../../../app/router/paths";
import { ProposalDetailDesktop } from "../components/ProposalDetailDesktop";
import { ProposalDetailMobile } from "../components/ProposalDetailMobile";

const { useBreakpoint } = Grid;

interface ProposalDetailPageProps {
    isDesktop?: boolean;
    onBackToList?: () => void;
}

export const ProposalDetailPage: React.FC<ProposalDetailPageProps> = ({
    isDesktop: propIsDesktop,
    onBackToList
}) => {
    const { proposalId, id } = useParams<{ proposalId?: string; id?: string }>();
    const screens = useBreakpoint();
    const isDesktop = propIsDesktop ?? !!screens.md;
    const [proposal, setProposalDetail] = useState<ProposalDetail>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    const targetId = proposalId || id;

    const handleBack = () => {
        if (onBackToList) {
            onBackToList();
        } else {
            navigate(PATHS.PROPOSAL);
        }
    };

    const handleCreateOrder = () => {
        // Logic xử lý khi click Tạo Order
    };

    const handleExport = () => {
        // Logic xử lý khi click Export
    };

    const fetchProposalDetail = useCallback(async () => {
        if (!targetId || Number.isNaN(Number(targetId))) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = await proposalApi.getProposalById(Number(targetId));
            setProposalDetail(ConvertProposalDetail(response));
        } catch (error) {
            console.error("Failed to fetch proposal detail:", error);
        } finally {
            setIsLoading(false);
        }
    }, [targetId]);

    useEffect(() => {
        fetchProposalDetail();
    }, [fetchProposalDetail]);

    return (
        <div style={{ width: '100%', minHeight: '100vh', backgroundColor: '#F8F9FA', position: 'relative' }}>
            {isLoading && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.5)"
                }}>
                    <Spin size="large" >
                        <span style={{ marginTop: 12, color: "#1890ff", fontWeight: 500 }}>
                            提案詳細を読み込み中...{/* Đang tải chi tiết đề xuất... */}
                        </span>
                    </Spin>
                </div>
            )}

            {isDesktop ? (
                <ProposalDetailDesktop
                    proposal={proposal}
                    onCreateOrder={handleCreateOrder}
                    onExport={handleExport}
                />
            ) : (
                <ProposalDetailMobile
                    proposal={proposal}
                    handleBack={handleBack}
                    onCreateOrder={handleCreateOrder}
                />
            )}
        </div>
    );
};